import { Heart, Instagram } from "lucide-react";
import { Flags } from "./motion";
import {
  ADDRESS_1,
  ADDRESS_2,
  INSTAGRAM_URL,
  PHONE_DISPLAY,
  PHONE_TEL,
} from "./data";

const Footer = () => (
  <footer
    data-testid="footer"
    className="bg-ink pb-24 pt-16 text-paper md:pb-16"
  >
    <div className="mx-auto max-w-[1500px] px-4 sm:px-6">
      <div className="flex flex-wrap items-end justify-between gap-6 border-b-2 border-dashed border-paper/25 pb-10">
        <div>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-3 font-display text-4xl uppercase leading-none sm:text-7xl">
            <span className="barber-pole barber-pole-md shrink-0" aria-hidden="true">
              <span className="barber-pole-cap" />
              <span className="barber-pole-glass" />
              <span className="barber-pole-cap" />
            </span>
            <span className="flex flex-wrap items-center gap-x-4 gap-y-2">
              Oliver&rsquo;s <Flags text="BARBER SHOP" size="lg" blueFrom={7} />
            </span>
          </p>
          <p className="mt-3 font-hand text-2xl text-paper/70">
            Good cuts. No BS.
          </p>
        </div>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          aria-label="Follow Oliver's Barber Shop on Instagram"
          className="inline-flex items-center gap-3 border-2 border-paper px-5 py-3 font-display text-lg uppercase tracking-wide text-white transition-transform duration-150 hover:-translate-y-0.5"
          style={{
            background:
              "linear-gradient(45deg, #feda75, #fa7e1e, #d62976, #962fbf, #4f5bd5)",
          }}
        >
          <Instagram size={22} /> Follow us on Instagram
        </a>
      </div>

      <div className="grid grid-cols-1 gap-10 py-10 sm:grid-cols-3">
        <div>
          <p className="font-mono2 text-[10px] font-bold uppercase tracking-[0.3em] text-rust">
            Find us
          </p>
          <p className="mt-3 text-sm font-medium leading-relaxed text-paper/80">
            {ADDRESS_1}
            <br />
            {ADDRESS_2}
          </p>
        </div>
        <div>
          <p className="font-mono2 text-[10px] font-bold uppercase tracking-[0.3em] text-rust">
            Call us
          </p>
          <a
            href={PHONE_TEL}
            data-testid="footer-phone-link"
            className="mt-3 inline-block font-display text-3xl uppercase transition-colors hover:text-rust"
          >
            {PHONE_DISPLAY}
          </a>
          <p className="mt-2 font-hand text-lg text-paper/70">
            Walk ins preferred
          </p>
        </div>
        <div>
          <p className="font-mono2 text-[10px] font-bold uppercase tracking-[0.3em] text-rust">
            Hours
          </p>
          <p className="mt-3 font-mono2 text-sm leading-relaxed text-paper/80">
            MON–FRI 10AM–6PM
            <br />
            SAT 10AM–5PM
            <br />
            SUN CLOSED
          </p>
        </div>
      </div>

      <div
        data-testid="acknowledgment"
        className="flex flex-wrap items-center justify-center gap-5 py-8"
      >
        <svg
          viewBox="0 0 30 20"
          className="h-6 w-9 -rotate-2"
          role="img"
          aria-label="Aboriginal flag"
        >
          <rect width="30" height="10" fill="#000000" />
          <rect y="10" width="30" height="10" fill="#d43a2f" />
          <circle cx="15" cy="10" r="5" fill="#f2c500" />
        </svg>
        <p className="max-w-2xl text-center font-mono2 text-[11px] leading-relaxed tracking-wide text-paper/70">
          We acknowledge the Traditional Custodians of the land on which we live
          and work. We pay our respects to Elders past and present, and honour
          their enduring connection to Country, culture and community.
        </p>
      </div>

      <div className="flex flex-col items-center gap-4 border-t-2 border-dashed border-paper/25 pt-6 font-mono2 text-[10px] uppercase tracking-[0.15em] text-paper/50 sm:flex-row sm:justify-between sm:tracking-[0.3em]">
        <p className="whitespace-nowrap">&copy; 2026 Oliver&rsquo;s Barber Shop — St Kilda VIC</p>
        <a
          href="https://lcreativestudio.co/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-credit-link"
          className="inline-flex items-center gap-1.5 whitespace-nowrap font-bold text-paper"
        >
          Built with{" "}
          <Heart size={11} style={{ fill: "#d43a2f", color: "#d43a2f" }} aria-label="love" /> by{" "}
          <span
            className="underline decoration-2 underline-offset-4"
            style={{ color: "#ff4f00", textDecorationColor: "#ff4f00" }}
          >
            LCreative Studio
          </span>
          <span className="text-paper"> - Melbourne</span>
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
